export default {
    newsList:'/course/official/article/query/page',
    newsDetail:'/course/official/article/query'
}